/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Rate request
 */
export interface RateRequest {
  /**
   * Pair IDs for execution. Only LP pairs with same basePairId allowed.
   */
  pairIds: Array<number>;
  /**
   * Commission rate. 1 = 0.001%
   */
  commissionRate: number;
  /**
   * Client request
   */
  clientRequest: number;
  /**
   * Is client request in base currency or not
   */
  clientRequestInBaseCurrency: boolean;
  /**
   * Account ID.
   */
  accountId: number;
}
